module.exports = __webpack_public_path__ + "static/media/smoke.e6021d72.jpg";